module.exports = __webpack_public_path__ + "img/coupon_get_icon@2x.bc960e14.png";